<template>
  <span
      :class="`badge badge-pill badge-${color} px-2 text-capitalize font-weight-lighter`"
      v-text="value"
      :data-toggle="hint ? 'tooltip' : null"
      :title="hint"
      data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner smaller text-center"></div></div>'
      data-placeholder="top"
  />
</template>

<script>
const ALLOWED_TYPES = ['Physical', 'Digital'];

export default {
  props: {
    value: {
      type: [String, null, undefined],
      required: true
    },
    showHint: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  computed: {
    color() {
      const mapColors = {
        [ALLOWED_TYPES[0]]: 'success',
        [ALLOWED_TYPES[1]]: 'info',
        default: 'secondary'
      };

      return mapColors[this.value] || mapColors.default;
    },

    hint() {
      if (!ALLOWED_TYPES.includes(this.value))
        return null;

      return this.showHint && `This product is allowed for the ${this.value} workflow only`;
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    }
  }
}
</script>
